import { ZoomOutButton } from 'components/shared';
import { DEFAULT_BRUSH_ZOOM_CONFIG } from 'config';
import { useSynthOIPutCallImpactCtx } from './useSynthOIPutCallImpactCtx';

export const SynthOIPutCallImpactZoomOutButton = () => {
  const { zoomConfig, setZoomConfig, chartData } = useSynthOIPutCallImpactCtx();

  return (
    <ZoomOutButton
      zoomConfig={zoomConfig}
      setZoomConfig={setZoomConfig}
      initialData={chartData}
      overrideDefault={{
        leftIdx: DEFAULT_BRUSH_ZOOM_CONFIG.leftIdx,
        rightIdx: chartData.length - 1,
      }}
    />
  );
};
